import styled, { css } from 'styled-components'
import { color } from 'ui/themes/utils'

import LabelElement from 'ui/elements/Label'
import DescriptionElement from 'ui/elements/Description'

export const Switch = styled.div`
  position: relative;

  min-height: 19px;

  padding-top: 4px;
  padding-left: 43px;

  ${({ mirror }) => mirror && css`
    display: flex;
    flex-direction: row-reverse;

    & > * {
      position: relative !important;
    }
    /* 😭 */
  `}
`

export const Input = styled.input`
  position: absolute;
  height: 0 !important;
  width: 0;
  visibility: hidden;
`

export const Toggle = styled.label`
  /* Override Booqable css styles */
  /* TODO: Remove this  */
  &&& {
    position: ${({ relative }) => relative ? 'relative' : 'absolute'};
    display: ${({ block }) => block ? 'block' : 'inline-block'};

    left: 0;

    width: 33px;
    height: 19px;

    margin: 0%;

    background: ${color('Misc/Divider')};

    border-radius: 100px;
    transition: background 0.3s, opacity 0.15s;

    cursor: pointer;

    &:after {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;

      width: 15px;
      height: 15px;

      background: ${color('white')};

      border-radius: 50%;
      transition: 0.25s cubic-bezier(0.18, 0.89, 0.32, 1.28);
    }

    ${({ withActiveEffect }) => withActiveEffect && css`
      &:active:after {
        width: 17px;
      }
    `}

    ${({ checked }) => checked && css`
      background: ${color('Primary/Base')};

      &:after {
        left: calc(100% - 2px);
        transform: translateX(-100%);
      }
    `}

    ${({ disabled }) => disabled && css`
      cursor: default;
      opacity: 0.6;
      pointer-events: none;
    `}
  }
`

export const Label = styled(LabelElement)`
  padding-top: 0.3em;
`

export const Description = styled(DescriptionElement)`
  margin: 0;
`
